import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 22 22",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.338 2.255v17.49a1.5 1.5 0 0 0 2.209 1.322l16.323-8.745a1.5 1.5 0 0 0 0-2.644L3.547.933a1.5 1.5 0 0 0-2.209 1.322v0Z",
		stroke: "#262626",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2022%2022%22%3E%3Cpath%20d%3D%22M1.338%202.255v17.49a1.5%201.5%200%200%200%202.209%201.322l16.323-8.745a1.5%201.5%200%200%200%200-2.644L3.547.933a1.5%201.5%200%200%200-2.209%201.322v0Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
